import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './projects.css';

const diningAreaImages = [
  { id: 1, thumbnail: '../images/interior3/КАФЕ_В3.png', fullImage: '../images/interior3/КАФЕ_В3.png' },
  { id: 2, thumbnail: '../images/interior3/КОФЕ_ПОЙНТ.png', fullImage: '../images/interior3/КОФЕ_ПОЙНТ.png' },
  { id: 3, thumbnail: '../images/interior3/КОФЕ_ПОЙНТ_1.png', fullImage: '../images/interior3/КОФЕ_ПОЙНТ_1.png' },
  { id: 4, thumbnail: '../images/interior3/кафе В1.png', fullImage: '../images/interior3/кафе В1.png' },
  { id: 5, thumbnail: '../images/interior3/кафе В2.png', fullImage: '../images/interior3/кафе В2.png' },
  { id: 6, thumbnail: '../images/interior3/CAFE.png', fullImage: '../images/interior3/CAFE.png' },
  { id: 7, thumbnail: '../images/interior3/CAFE1.png', fullImage: '../images/interior3/CAFE1.png' },
  { id: 8, thumbnail: '../images/interior3/CAFE2.png', fullImage: '../images/interior3/CAFE2.png' },
  { id: 9, thumbnail: '../images/interior3/GARM.png', fullImage: '../images/interior3/GARM.png' },
  { id: 10, thumbnail: '../images/interior3/GARM_1.png', fullImage: '../images/interior3/GARM_1.png' },
  { id: 11, thumbnail: '../images/interior3/GARM_2.png', fullImage: '../images/interior3/GARM_2.png' },
  // Add more images as needed
];

function DiningArea() {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/interior-designs');
  };

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  const handleClose = () => {
    setSelectedImageIndex(null);
  };

  const handlePrev = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : diningAreaImages.length - 1));
  };

  const handleNext = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex < diningAreaImages.length - 1 ? prevIndex + 1 : 0));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (selectedImageIndex !== null) {
        if (event.key === 'ArrowLeft') {
          handlePrev();
        } else if (event.key === 'ArrowRight') {
          handleNext();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImageIndex]);

  return (
    <div className="project-detail">
      <button className="back-button" onClick={handleBack}>НАЗАД ВО ВСЕ ИНТЕРЬЕРЫ</button>
      <div className="project-detail-grid">
        {diningAreaImages.map((image, index) => (
          <div key={image.id} className="project-detail-item">
            <img
              src={image.thumbnail}
              alt={`Dining Area Image ${index + 1}`}
              onClick={() => handleImageClick(index)}
            />
          </div>
        ))}
      </div>

      <button className="back-button back-button-end" onClick={handleBack}>НАЗАД ВО ВСЕ ИНТЕРЬЕРЫ</button>

      {selectedImageIndex !== null && (
        <div className="project-popup" onClick={handleClose}>
          <div className="project-popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleClose}>X</button>
            <button className="nav-button left" onClick={handlePrev}>&lt;</button>
            <img src={diningAreaImages[selectedImageIndex].fullImage} alt={`Dining Area Image ${selectedImageIndex + 1}`} />
            <button className="nav-button right" onClick={handleNext}>&gt;</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DiningArea; 